import { render } from "./GatePassConflictModal.vue?vue&type=template&id=56908be1&scoped=true"
import script from "./GatePassConflictModal.vue?vue&type=script&lang=js"
export * from "./GatePassConflictModal.vue?vue&type=script&lang=js"

import "./GatePassConflictModal.vue?vue&type=style&index=0&id=56908be1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56908be1"]])

export default __exports__